import SectionHeading from "./SectionHeading";
import { features } from "@/mocks/homeContent";

export default function Features() {
  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Why Xingchen"
          title="为什么选择星辰影视客户端"
          desc="从资源、画质到多端同步，客户端围绕“找得到、看得顺、接着看”三个核心体验展开，下面六项能力覆盖日常观影最常遇到的场景。"
        />

        <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, index) => (
            <article
              key={item.id}
              className="group bg-background-100 border border-background-200 rounded-lg p-6 hover:border-primary-300 transition-colors"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              <span className="mt-4 inline-block text-xs font-label text-secondary-700 tracking-wide">
                0{index + 1}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}